export const ViewIds = {
    PERMISSIONS: 'permissions',
    COHORTS: 'cohorts',
};
